import React, { useEffect } from 'react'
import { useTX } from '@transifex/react'

// PRO-130: type-only + leaf imports — Transifex is boot-static; the
// `../api/consts` and `../hooks` barrels weld antd Select/Table machinery onto
// the entry chunk (see AntdI18n).
import type { TCoreIoUserLanguageChoices } from '../api/consts/CoreIoUserLanguageChoices'
import { useMe } from '../hooks/useMe'

// SLICE4-F3 (RD-38): DE -> 'de' activates the German UI locale so the
// hauler module's de catalog renders (the BE now offers 'de' as a user
// language — core/0279). Typed Record<string, string> (not the narrow
// TCoreIoUserLanguageChoices) so adding a launch language here never
// forces a matching key in every other map over that union; the platform
// language union itself is a separate (larger) change. An unmapped
// language still falls back to English below, loudly.
const transifexLangMap: Record<string, string> = {
  DA: 'da',
  EN: 'en',
  NO: 'no_NO',
  FI: 'fi',
  SV: 'sv',
  DE: 'de',
}

/**
 * Set transifex language based on user setting
 */
const Transifex = () => {
  const me = useMe()
  const tx = useTX()

  const userLanguage = me?.language as TCoreIoUserLanguageChoices

  useEffect(() => {
    if (userLanguage) {
      const isLangSupported = transifexLangMap[userLanguage]
      if (isLangSupported) {
        tx.setCurrentLocale(isLangSupported)
      } else {
        // eslint-disable-next-line no-console
        console.log(
          new Error(`
        User language: ${userLanguage} is not supported by transifex.
        Setting language to en as fallback.
        `)
        )
      }
    }
  }, [userLanguage, tx])

  return <></>
}

export default Transifex
